/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RateRuleSetRulesInner
 */
export interface RateRuleSetRulesInner {
    /**
     * 
     * @type {string}
     * @memberof RateRuleSetRulesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RateRuleSetRulesInner
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof RateRuleSetRulesInner
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof RateRuleSetRulesInner
     */
    'merchantCategoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRuleSetRulesInner
     */
    'merchantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRuleSetRulesInner
     */
    'binSponsor'?: RateRuleSetRulesInnerBinSponsorEnum;
    /**
     * 
     * @type {string}
     * @memberof RateRuleSetRulesInner
     */
    'creditOrPrepaid'?: RateRuleSetRulesInnerCreditOrPrepaidEnum;
    /**
     * 
     * @type {number}
     * @memberof RateRuleSetRulesInner
     */
    'minimumTotalAmount': number;
}

export const RateRuleSetRulesInnerBinSponsorEnum = {
    lc: 'LC',
    cs: 'CS'
} as const;

export type RateRuleSetRulesInnerBinSponsorEnum = typeof RateRuleSetRulesInnerBinSponsorEnum[keyof typeof RateRuleSetRulesInnerBinSponsorEnum];
export const RateRuleSetRulesInnerCreditOrPrepaidEnum = {
    credit: 'CREDIT',
    prepaid: 'PREPAID'
} as const;

export type RateRuleSetRulesInnerCreditOrPrepaidEnum = typeof RateRuleSetRulesInnerCreditOrPrepaidEnum[keyof typeof RateRuleSetRulesInnerCreditOrPrepaidEnum];


